import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, " Reassessment Claim -2 Bill Information ")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_13 = { class: "col-md-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Contract", -1)
const _hoisted_15 = { class: "col-md-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Bill", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = { class: "col-md-2 mt-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_20 = {
  key: 0,
  class: "d-flex pt-4 pb-2"
}
const _hoisted_21 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_22 = { class: "fw-bold" }
const _hoisted_23 = { class: "fs-6 text-gray-600" }
const _hoisted_24 = { class: "mt-2" }
const _hoisted_25 = { class: "text-info" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("b", { class: "text-primary" }, "Note:", -1)
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "mt-6" }
const _hoisted_29 = { class: "card mb-5 mb-xl-10 mt-4" }
const _hoisted_30 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_31 = { class: "collapse show" }
const _hoisted_32 = { class: "card-body border-top p-6" }
const _hoisted_33 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_34 = { class: "table-responsive mt-5" }
const _hoisted_35 = { class: "table table-borderless gy-4" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-primary" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Sl"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"25%"} }, "Training Institutes"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"18%"} }, "Course"),
    /*#__PURE__*/_createElementVNode("th", null, "BN"),
    /*#__PURE__*/_createElementVNode("th", null, "Trainee Count"),
    /*#__PURE__*/_createElementVNode("th", null, "Unit Cost"),
    /*#__PURE__*/_createElementVNode("th", null, "Pay %"),
    /*#__PURE__*/_createElementVNode("th", null, "Payment Amount"),
    /*#__PURE__*/_createElementVNode("th", null, "Bill Amount")
  ])
], -1)
const _hoisted_37 = { style: {} }
const _hoisted_38 = { class: "align-middle" }
const _hoisted_39 = { class: "align-middle" }
const _hoisted_40 = { class: "align-middle" }
const _hoisted_41 = { class: "align-middle" }
const _hoisted_42 = { class: "align-middle" }
const _hoisted_43 = { class: "align-middle" }
const _hoisted_44 = { class: "align-middle" }
const _hoisted_45 = { class: "align-middle" }
const _hoisted_46 = { class: "align-middle" }
const _hoisted_47 = { style: {"border-bottom":"1px solid\r\n                                    rgba(29, 182, 140, 0.51) !important"} }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("th", { class: "font-weight-bold text-primary" }, " Total ", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_51 = { class: "font-weight-bold text-primary" }
const _hoisted_52 = { class: "font-weight-bold text-primary" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_56 = { class: "font-weight-bold text-primary" }
const _hoisted_57 = { style: {"border-bottom":"1px solid\r\n                                    rgba(29, 182, 140, 0.51) !important"} }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("th", {
  colspan: "8",
  class: "font-weight-bold text-primary text-end"
}, " A) Gross Amount ", -1)
const _hoisted_59 = { class: "font-weight-bold text-primary" }
const _hoisted_60 = { style: {"border-bottom":"1px solid\r\n                                    rgba(29, 182, 140, 0.51) !important"} }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("th", {
  colspan: "8",
  class: "font-weight-bold text-primary text-end"
}, " B) IA'S Contribution ", -1)
const _hoisted_62 = { class: "font-weight-bold text-primary" }
const _hoisted_63 = { style: {"border-bottom":"1px solid\r\n                                    rgba(29, 182, 140, 0.51) !important"} }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("th", {
  colspan: "8",
  class: "font-weight-bold text-primary text-end"
}, " C) Contribution Amount (A*B) ", -1)
const _hoisted_65 = { class: "font-weight-bold text-primary" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("th", {
  colspan: "8",
  class: "font-weight-bold text-primary text-end"
}, " D) Net Payable (A - C) ", -1)
const _hoisted_67 = { class: "font-weight-bold text-primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _hoisted_10,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select Tranche",
                  modelValue: _ctx.bill.tranche_id,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.bill.tranche_id) = $event)),
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches, (trans) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: trans.id,
                        label: trans.label,
                        value: trans.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(trans.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select Partner",
                  modelValue: _ctx.bill.entity_id,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.bill.entity_id) = $event)),
                  filterable: "",
                  style: {"width":"100%"},
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getEntityContract()))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (data) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: data.id,
                        label: data.entity_short_name,
                        value: data.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("[" + _toDisplayString(data.entity_short_name) + "]-" + _toDisplayString(data.entity_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select Contract",
                  modelValue: _ctx.bill.entity_contract_id,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.bill.entity_contract_id) = $event)),
                  filterable: "",
                  style: {"width":"100%"},
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getAllBillNo()))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contractInfos, (data) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: data.id,
                        label: data.contract_name,
                        value: data.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(data.contract_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _hoisted_17,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select Bill",
                  modelValue: _ctx.bill.bill_no,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.bill.bill_no) = $event)),
                  filterable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allBillNo, (bl) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: bl.bill_sequence_no,
                        label: bl.bill_no,
                        value: bl.bill_sequence_no
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(bl.bill_no), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("button", {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getBillList())),
                  type: "submit",
                  class: "btn btn-success p-3 mt-6",
                  style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                }, [
                  _createTextVNode(" Search "),
                  _hoisted_19
                ])
              ])
            ]),
            (_ctx.showBillList == true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("p", _hoisted_25, [
                            _hoisted_26,
                            _createTextVNode(" " + _toDisplayString(_ctx.status), 1)
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.showBillList)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createElementVNode("h4", _hoisted_28, " Reassessment Claim -2 Bill Detail (Total Batch Found : " + _toDisplayString(_ctx.billList.length) + ") ", 1),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, [
                              _createElementVNode("table", _hoisted_35, [
                                _hoisted_36,
                                _createElementVNode("tbody", _hoisted_37, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billList, (data, index) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      key: index,
                                      style: {"border-bottom":"1px solid\r\n                                      rgba(29, 182, 140, 0.51) !important"}
                                    }, [
                                      _createElementVNode("td", _hoisted_38, _toDisplayString(index + 1), 1),
                                      _createElementVNode("td", _hoisted_39, _toDisplayString(data?.institute_info?.institute_name) + " ( " + _toDisplayString(data?.institute_info?.short_name) + " ) ", 1),
                                      _createElementVNode("td", _hoisted_40, _toDisplayString(data?.course_info?.course_name) + " | " + _toDisplayString(data?.course_info?.month) + " | " + _toDisplayString(data?.course_info?.hour) + " | " + _toDisplayString(data?.course_info?.total_course_cost), 1),
                                      _createElementVNode("td", _hoisted_41, _toDisplayString(data?.batch_info?.batch_number), 1),
                                      _createElementVNode("td", _hoisted_42, _toDisplayString(data.trainee_count), 1),
                                      _createElementVNode("td", _hoisted_43, _toDisplayString(data.unit_cost), 1),
                                      _createElementVNode("td", _hoisted_44, _toDisplayString(data.pay_percentage), 1),
                                      _createElementVNode("td", _hoisted_45, _toDisplayString(data.net_payable), 1),
                                      _createElementVNode("td", _hoisted_46, _toDisplayString(data.bill_amount), 1)
                                    ]))
                                  }), 128))
                                ]),
                                _createElementVNode("tfoot", null, [
                                  _createElementVNode("tr", _hoisted_47, [
                                    _hoisted_48,
                                    _hoisted_49,
                                    _hoisted_50,
                                    _createElementVNode("th", _hoisted_51, _toDisplayString(_ctx.billList.length), 1),
                                    _createElementVNode("th", _hoisted_52, _toDisplayString(Number(this.tolatTrainee).toLocaleString()), 1),
                                    _hoisted_53,
                                    _hoisted_54,
                                    _hoisted_55,
                                    _createElementVNode("th", _hoisted_56, _toDisplayString(Number(
                                      this.tolatBillAmount
                                    ).toLocaleString()), 1)
                                  ]),
                                  _createElementVNode("tr", _hoisted_57, [
                                    _hoisted_58,
                                    _createElementVNode("th", _hoisted_59, _toDisplayString(Number(
                                      this.tolatBillAmount
                                    ).toLocaleString()), 1)
                                  ]),
                                  _createElementVNode("tr", _hoisted_60, [
                                    _hoisted_61,
                                    _createElementVNode("th", _hoisted_62, _toDisplayString(Number(
                                      this.contributionPay
                                    ).toLocaleString()) + "% ", 1)
                                  ]),
                                  _createElementVNode("tr", _hoisted_63, [
                                    _hoisted_64,
                                    _createElementVNode("th", _hoisted_65, _toDisplayString(this.totalContributionAmount.toFixed(2)), 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_66,
                                    _createElementVNode("th", _hoisted_67, _toDisplayString(this.totalPayableAmount.toFixed(2)), 1)
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}